<div *ngFor="let txt of languageDetails">
    <mat-checkbox class="example-margin" [checked]="selectedLanguages.includes(txt['name'])"
                  (change)="addType($event, txt['name'])">{{txt['name']}}
    </mat-checkbox>
</div>
